import Image, { type ImageProps } from 'next/image';

export const Img = (props: ImageProps) => {
  const shouldUnoptimize =
    typeof props.src === 'string' &&
    props.src.includes('assetscms.foodango.pl');

  return <Image {...props} unoptimized={shouldUnoptimize} />;
};
